import React from 'react';
import { Mail, AlertCircle, Inbox, Settings } from 'lucide-react';
import { Button } from '../../ui/button';

export default function CrmMailEmptyState({
  variant = 'folder',
  onCompose,
  canConfigure = false,
  onConfigure,
}) {
  if (variant === 'not-configured') {
    return (
      <div className="flex flex-col items-center justify-center h-full min-h-[320px] p-8 text-center">
        <div className="rounded-full bg-muted p-4 mb-4">
          <AlertCircle className="w-10 h-10 text-muted-foreground" />
        </div>
        <h2 className="text-lg font-semibold mb-2">Mail not configured</h2>
        <p className="text-muted-foreground max-w-sm mb-4">
          {canConfigure
            ? 'Set up your IMAP/SMTP account to start sending and receiving mail.'
            : 'Mail account not set up. Please contact your administrator.'}
        </p>
        {canConfigure && onConfigure && (
          <Button onClick={onConfigure} className="bg-blue-600 hover:bg-blue-700 text-white">
            <Settings className="w-4 h-4 mr-2" />
            Configure Mail
          </Button>
        )}
      </div>
    );
  }

  if (variant === 'no-selection') {
    return (
      <div className="flex flex-col items-center justify-center h-full min-h-[320px] p-8 text-center text-muted-foreground">
        <Mail className="w-12 h-12 mb-4 opacity-40" />
        <p>Select a message to read</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[200px] p-8 text-center">
      <Inbox className="w-10 h-10 text-muted-foreground mb-3 opacity-50" />
      <p className="text-muted-foreground mb-4">No messages in this folder</p>
      {onCompose && (
        <Button onClick={onCompose} size="sm" className="bg-blue-600 hover:bg-blue-700 text-white">
          Compose
        </Button>
      )}
    </div>
  );
}
